import React, { Component } from 'react';
import { connect } from 'react-redux';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { actions, errorMessages, fileUpload } from '../../../helpers/messages';


class LogUploadComponent extends Component {
    constructor(props) {
        super(props)
        this.inputOpenFileRef = React.createRef();
        this.state = {
            showConfirmModal: false
        }
    }

    /**
    * @description Function to open file dialog 
    * @memberof LogUploadComponent
    */
    /* istanbul ignore next  */
    showOpenFileDlg = () => {
        this.inputOpenFileRef.current.click()
    }

    /**
    * @description Function to open modal for confirmation for file upload cancel
    * @memberof LogUploadComponent
    */
    cancelUploadConfirmation = () => {
        this.setState({ showConfirmModal: true })
    }

    /**
    * @description Function to handle the action on upload confirmation modal
    * @memberof LogUploadComponent
    */
    cancelUploadAction = (action) => {
        if (action) {
            this.props.onFileUploadCancel();
        }
        this.setState({ showConfirmModal: false });
    }

    render() {
        const { onSubmit, onInputChange, isLoading, resetInput, displayFileName, uploadError, fileExtentionError,
            uploadProgress, fileExistInS3, disclaimerCheckBoxValue, maxFileSizeError, metaDataUpdateStatus, metaDataUpdateError, disclaimerCheckBoxChange,
            formErrors, errorMsgs, successMsgs, enableUploadBtn, enableCancelBtn, showProgress, cancelFileUploadStatus, toggleUploadModal } = this.props;
        const { showConfirmModal } = this.state;
        const isUploadInProgress = uploadProgress > 0 && enableCancelBtn;
        const isDisableUploadCancel = !isUploadInProgress || uploadProgress > 80
        return (
            <div className="log-upload">
                {showConfirmModal ? <>
                    <div className="row">
                        <div className="col-sm-12 tect-center">
                            <p className="m-0">{fileUpload.cancelConfirmationText}</p>
                        </div>
                        <hr />
                        <div className="col-sm-12 text-end">
                            <button className="btn btn-primary" id="cancel-upload" data-testid="cancelUploadBtn" onClick={(e) => this.cancelUploadAction(true)}>Yes</button>
                            <button className="btn btn-secondary ms-2" id="cancel-upload" data-testid="rejectCancelUploadBtn" onClick={(e) => this.cancelUploadAction(false)}>No</button>
                        </div>
                    </div>
                </> : !cancelFileUploadStatus && showProgress ? <>
                    <div className="row">
                        <div className="col-sm-12">
                            <p className="mb-2">Uploading...</p>
                            {isUploadInProgress || (isLoading && metaDataUpdateStatus === '') ?
                                <ProgressBar now={uploadProgress} label={`${uploadProgress}%`} animated />
                                : ''}
                        </div>
                        <hr className="my-3" />
                        <div className="col-sm-12 text-end mt-4">
                            <button className="btn btn-secondary" id="cancel-upload" data-testid="cancelUploadBtn" disabled={isDisableUploadCancel} onClick={this.cancelUploadConfirmation}>Cancel Upload</button>
                        </div>
                    </div>
                </> : <>
                    {isLoading ? <div className="loading-overlay upload-log-overlay"><span>{actions.load}</span></div> : ''}
                    <div className="body body-section">
                        {metaDataUpdateStatus === 'success' && successMsgs && !cancelFileUploadStatus ?
                            <div className="success-msg">
                                <p>{successMsgs.fileUploadSuccess}</p>
                            </div>
                            : ''}
                        {uploadError && cancelFileUploadStatus ?
                            <div className="top-error-msg">
                                <p>{uploadError}</p>
                            </div>
                            : ''}
                        {metaDataUpdateStatus === 'fail' ?
                            <div className="top-error-msg">
                                <p>{metaDataUpdateError}</p>
                            </div>
                            : ''}
                        <div className="file-selector-wrap">
                            <div className="form-lable"><label>Selected File<span className="red">*</span>: </label></div>
                            <div className="fileinputs form-input">
                                <input type="file" name="fileName" ref={this.inputOpenFileRef} data-testid="inputFile" id="inputFile" onChange={(e) => onInputChange(e.target.files)} onClick={resetInput} className="form-control file input-file" />
                                <div className="sudofile d-flex justify-content-between">
                                    <input placeholder="Select File" type="text" name="fileNames" disabled defaultValue={displayFileName} className="form-control input-file m-0 log-upload-input" />
                                    <button className="btn btn-outline-primary" onClick={this.showOpenFileDlg}>Browse</button>
                                </div>
                                {formErrors && formErrors.fileName ?(
                                    <div className="error-msg">
                                        <p>{formErrors.fileName}</p>
                                    </div>                                    
                                ): fileExtentionError ? (
                                    <div className="error-msg">
                                        <p>{errorMsgs.fileUpload.fileUpload}</p>
                                    </div>
                                ): maxFileSizeError ? (
                                    <div className="error-msg">
                                        <p>{errorMsgs.fileUpload.maxSizeAllowed}</p>
                                    </div>                                    
                                ): fileExistInS3 ?(
                                    <div className="error-msg">
                                        <p>{errorMsgs.fileUpload.duplicateFileName} </p>
                                    </div>
                                    ): null}
                            </div>
                        </div>

                        <div className="disclaimer-wrap">
                            <div className="form-lable facility-label"></div>
                            <div className="fileinputs form-input">
                                <div className="mrgtop-20">
                                    <label className="chk-label">
                                        <input type="checkbox" data-testid="disclaimerchk" id="disclaimerchk" className="chk-input" onChange={(e) => disclaimerCheckBoxChange(e)} checked={disclaimerCheckBoxValue === true} />
                                        <span className="red ms-1">*</span>
                                        &nbsp;{errorMessages.fileUpload.check1}<br />{errorMessages.fileUpload.check2}
                                    </label>
                                </div>
                                {formErrors && formErrors.disclaimerCheckBox ?
                                    <div className="error-msg" data-tserid="disclaimer">
                                        <p>{formErrors.disclaimerCheckBox}</p>
                                    </div>
                                    : ''}
                            </div>
                        </div>
                        <hr />
                        <div className="btns-style text-end">
                            <button className="btn btn-primary" id="fileUpload" data-testid="uploadBtn" onClick={onSubmit} disabled={!enableUploadBtn}>Upload</button>
                            <button className="btn btn-secondary ms-2" id="closeModal" data-testid="closeModalBtn" onClick={toggleUploadModal}>Close</button>
                        </div>
                    </div>
                </>
                }

            </div>
        );
    }
}
const mapStateToProps = (state) => (
    {
        state
    }
)
const mapDispatchToProps = (dispatch) => ({

})
export default connect(mapStateToProps, mapDispatchToProps)(LogUploadComponent);
